import { Profile } from '@app/core/models/profile';
import { Coverage } from '@app/core/models/coverage';
import { Financial } from '@app/core/models/financial';
import { Lifestyle } from '@app/core/models/lifestyle';
import { Needs } from '@app/core/models/needs';
import { AgentInfo } from '@app/core/models/agent';
import { Save } from './save';

export class Kyc {
  agentInfo: AgentInfo;
  profile: Profile;
  coverage: Coverage;
  financial: Financial;
  lifestyle: Lifestyle;
  needs: Needs;
  save: Save;

  constructor() {
    this.coverage = new Coverage();
    this.needs = new Needs();
    this.profile = new Profile();
    this.financial = new Financial();
    this.lifestyle = new Lifestyle();
    this.save = new Save();
  }

  complete() {
    this.profile.completed = true;
    this.coverage.completed = true;
    this.needs.completed = true;
    this.financial.completed = true;
    this.lifestyle.completed = true;
    this.save.completed = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/kyc.ts